import {
  CreateOperationalEntityInputV2,
  isClientEntityOperational
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlanNode} from "../view-model";
import {toCacmSource} from "./toCacmSource";
import {toOems} from "./toOems";
import {toOrganizationInformation} from "./toOrganizationInformation";

export const toCreateHierarchyInputV2 = (
  node: CreatePlanNode,
  transactionId?: string,
  tenantId?: string
): CreateOperationalEntityInputV2 | undefined => {
  if (node.selected) {
    if (isClientEntityOperational(node.source)) {
      const operationalEntity = node.source.mappedOperationalEntities?.[0];
      return {
        transactionId,
        id: operationalEntity?.id,
        sources: [toCacmSource(node.caId)],
        organizationInformation: {
          dbaName:
            operationalEntity?.organizationInformation?.dbaName ||
            node.source.custName,
          status:
            operationalEntity?.organizationInformation?.status || "IN BUSINESS"
        },
        oems: [],
        tenantId,
        children: node.children
          .map(child =>
            toCreateHierarchyInputV2(child, transactionId, tenantId)
          )
          .filter(input => !!input)
      };
    }
    return {
      transactionId,
      sources: [toCacmSource(node.caId)],
      organizationInformation: toOrganizationInformation(node.source),
      oems: node.source.clientNameplates
        ? toOems(node.source.clientNameplates)
        : [],
      tenantId,
      children: node.children
        .map(child => toCreateHierarchyInputV2(child, transactionId, tenantId))
        .filter(input => !!input)
    };
  }
};
